<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Refer & Earn</h2>

            <ul>
                <li>
                    <a routerLink="/">Home</a>
                </li>

                <li>Refer & Earn</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Refer Hero -->
<section class="refer-earn-hero ptb-100">
    <div class="container">
        <div class="refer-hero-box">
            <div class="refer-hero-content">
                <span class="refer-tag"> SolarCiti Referral Program </span>

                <h1>
                    Refer SolarCiti &
                    <span>Earn Up to ₹5,000</span>
                </h1>

                <p>
                    Know someone who is planning to install solar? Refer them to
                    SolarCiti and get rewarded when their solar project is
                    successfully completed.
                </p>

                <div class="refer-hero-buttons">
                    <a routerLink="/contact" class="btn btn-primary">
                        Refer Someone
                        <i class="flaticon-right"></i>
                    </a>

                </div>
            </div>

            <div class="refer-reward-card">
                <div class="reward-icon">
                    <i class="bx bx-gift"></i>
                </div>
                <span>Referral Reward</span>
                <h2>₹5,000</h2>
                <p>Earn up to ₹5,000 for a successful referral.</p>
                <div class="reward-line"></div>
                <small> Terms & eligibility apply </small>
            </div>
        </div>
    </div>
</section>
<!-- End Refer Hero -->

<!-- Start How It Works -->
<section class="refer-how-area ptb-100 bg-f7f9fc" id="how-it-works">
    <div class="container">
        <div class="section-title">
            <span>Simple & Rewarding</span>

            <h2>How Refer & Earn Works</h2>

            <p>
                Refer someone who is interested in solar and let SolarCiti take
                care of the rest.
            </p>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="refer-step-card">
                    <div class="refer-step-top">
                        <span>01</span>

                        <div class="refer-step-icon">
                            <i class="bx bx-user-plus"></i>
                        </div>
                    </div>

                    <h3>Refer a Friend</h3>

                    <p>
                        Share the details of someone who is interested in
                        installing a solar system.
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="refer-step-card">
                    <div class="refer-step-top">
                        <span>02</span>

                        <div class="refer-step-icon">
                            <i class="bx bx-phone-call"></i>
                        </div>
                    </div>

                    <h3>We Connect</h3>

                    <p>
                        Our SolarCiti team contacts the referred customer,
                        understands their requirements, and provides suitable
                        solar guidance.
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="refer-step-card">
                    <div class="refer-step-top">
                        <span>03</span>

                        <div class="refer-step-icon">
                            <i class="bx bx-wallet"></i>
                        </div>
                    </div>

                    <h3>Get Rewarded</h3>

                    <p>
                        When the referred customer completes an eligible solar
                        project, you can receive your referral reward of up to
                        ₹5,000.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End How It Works -->

<!-- Start Why Refer -->
<section class="refer-benefits-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="refer-benefits-content">
                    <span> Why Refer SolarCiti? </span>

                    <h2>
                        Help Someone Go Solar
                        <strong>While You Earn</strong>
                    </h2>

                    <p>
                        Your recommendation can help friends, family,
                        neighbours, or business owners explore a cleaner and
                        smarter way to manage their electricity needs.
                    </p>

                    <ul>
                        <li>
                            <i class="bx bx-check-circle"></i>
                            Earn up to ₹5,000 on eligible referrals
                        </li>

                        <li>
                            <i class="bx bx-check-circle"></i>
                            Easy referral process
                        </li>

                        <li>
                            <i class="bx bx-check-circle"></i>
                            Help others discover solar solutions
                        </li>

                        <li>
                            <i class="bx bx-check-circle"></i>
                            SolarCiti team handles the consultation
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="refer-benefit-highlight">
                    <div class="benefit-circle">
                        <i class="bx bx-sun"></i>
                    </div>

                    <span> Your Referral Can Make a Difference </span>

                    <h3>
                        Recommend Solar.
                        <br />
                        Earn Rewards.
                    </h3>

                    <p>
                        Introduce someone to SolarCiti and help them take the
                        next step towards solar energy.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Why Refer -->

<!-- Start Eligibility -->
<section class="refer-eligibility-area ptb-100 bg-fafafa">
    <div class="container">
        <div class="section-title">
            <span>Before You Refer</span>

            <h2>Referral Eligibility</h2>

            <p>
                A few simple conditions help us make sure every referral is
                genuine and eligible for the program.
            </p>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="eligibility-card">
                    <div class="eligibility-icon">
                        <i class="bx bx-user-check"></i>
                    </div>

                    <h3>New Customer</h3>

                    <p>
                        The referred person should be a new customer who has not
                        already registered an enquiry with SolarCiti.
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="eligibility-card">
                    <div class="eligibility-icon">
                        <i class="bx bx-sun"></i>
                    </div>

                    <h3>Eligible Solar Project</h3>

                    <p>
                        The referral reward applies to qualifying solar projects
                        as defined under the SolarCiti referral program.
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="eligibility-card">
                    <div class="eligibility-icon">
                        <i class="bx bx-check-shield"></i>
                    </div>

                    <h3>Successful Completion</h3>

                    <p>
                        The referral reward becomes applicable after the
                        referred customer completes the qualifying process or
                        project requirements.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Eligibility -->

<!-- Start CTA -->
<section class="refer-cta-area pt-100">
    <div class="container">
        <div class="refer-cta-box">
            <div>
                <span> Ready to Refer? </span>
                <h2>Know Someone Who Should Go Solar?</h2>
                <p>
                    Refer them to SolarCiti and get a chance to earn up to
                    ₹5,000.
                </p>
            </div>
            <a routerLink="/contact" class="btn btn-primary">
                Start Your Referral
                <i class="flaticon-right"></i>
            </a>
        </div>
    </div>
</section>
<!-- End CTA -->

<!-- Start Terms Note -->
<section class="refer-terms-area">
    <div class="container">
        <div class="refer-terms">
            <i class="bx bx-info-circle"></i>

            <div>
                <h3>Referral Program Terms</h3>

                <p>
                    Referral rewards are subject to eligibility, applicable
                    terms, verification, and successful completion of the
                    qualifying solar project. SolarCiti reserves the right to
                    modify or discontinue the referral program in accordance
                    with its applicable terms and policies.
                </p>
            </div>
        </div>
    </div>
</section>
<!-- End Terms Note -->
